export default __webpack_public_path__ + "resources/icons/n103-29a8.png";